<template>
  <div>
    <div
      v-for="(item, i) in commentMessages"
      :key="i"
      class="mt-5 comment-container px-2 py-2"
    >
      <v-row align="start">
        <v-col cols="12" lg="1" md="1">
          <v-row align="center" justify="space-between">
            <v-col cols="9">
              <v-avatar class="mt-1" color="primary" size="30">
                <img
                  v-if="item.owner.profile.avatar"
                  :src="item.owner.profile.avatar"
                  alt="blog owner image"
                />
                <span v-else class="white--text text-h5">
                  {{ item.owner.email.charAt(0).toUpperCase() }}
                </span>
              </v-avatar>
            </v-col>
            <v-col cols="3" v-if="$vuetify.breakpoint.xs">
              <v-col
                v-if="isAuthenticated && item.owner.uuid === user.uuid"
                class="d-flex flex-row"
                cols="12"
                lg="1"
                md="1"
              >
                <v-menu bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                      <v-icon color="primary">
                        mdi-dots-horizontal-circle
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item>
                      <v-list-item-title
                          class="action"
                          @click="setEditMode(i)"
                        >
                        Edit
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title
                        class="action"
                        @click="setDeleteMode(i)">
                        Delete
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" lg="11" md="11">
          <v-row align="start" justify="space-evenly">
            <v-col :cols="!$vuetify.breakpoint.xs ? 10 : 12">
              <div class="text-no-wrap d-flex flex-column flex-md-row">
                <h4>{{ getDisplayNameOrEmail(item.owner) }}</h4>
                <div>
                  <v-chip
                      small
                      class="ml-1 text-capitalize mb-1"
                      style="color: #0033AA"
                      v-for="(type, i) in getAccountTypeTag(item.owner)"
                      :key="i"
                  >
                    {{type.toLowerCase()}}
                  </v-chip>
                </div>
              </div>
              <div class="comment--body">
                <p v-if="i !== commentEditIndex" v-html="item.body" />
                <template v-else>
                  <quill-editor
                    ref="myQuillEditor"
                    :disabled="commentSaveLoading"
                    :options="editorOptions"
                    :value="commentEditBody"
                    @change="onEditorChange($event)"

                  />

                  <v-row class="mt-2">
                    <v-col cols="7">
                      <v-btn
                        :disabled="updateCommentLoading || !commentEditBody"
                        :loading="updateCommentLoading"
                        color="primary"
                        small
                        @click="updateComment(commentEditBody)"
                        >Save Comment
                      </v-btn>
                    </v-col>
                    <v-col cols="5">
                      <v-btn
                          color="red"
                          outlined
                          small
                          @click="cancelEdit()"
                        >Cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
              </div>
            </v-col>
            <v-col cols="2" v-if="!$vuetify.breakpoint.xs">
              <template>
                <v-col
                  v-if="isAuthenticated && item.owner.uuid === user.uuid"
                  class="d-flex justify-start"
                  cols="12"
                  lg="1"
                  md="1"
                >
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="primary"
                          >mdi-dots-horizontal-circle</v-icon
                        >
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item>
                        <v-list-item-title
                          class="action"
                          @click="setEditMode(i)"
                          >Edit</v-list-item-title
                        >
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title
                          class="action"
                          @click="setDeleteMode(i)"
                          >Delete</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </template>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { getDisplayNameOrEmail, getAccountTypeTag } from "@/utilz/dispalyNameOrEmail";

export default {
  name: "Comments",
  data() {
    return {
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: {
             container: [
                ['link', 'image', 'video'],
                ["bold", "italic", "underline"],
                ["blockquote", "code-block"],
              ],
          },
        },
      },
    };
  },
  props: {
    commentEditBody: {
      type: String,
      default() {
        return "Guiomentor";
      },
    },
    comments: {
      type: Array,
      default() {
        return [];
      },
    },
    isAuthenticated: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isBlogs: {
      type: Boolean,
      default() {
        return true;
      },
    },
    user: {
      type: Object,
      default() {
        return {};
      },
    },
    commentEditIndex: {
      type: Number,
      default() {
        return null;
      },
    },
    updateCommentLoading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    commentSaveLoading: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    commentMessages() {
      return this.comments.map(comment => {
        if (!this.isBlogs) {
          return {
            uuid: comment.uuid,
            body: comment.message,
            owner: comment.user
          }
        } else return  comment
      })
    }
  },
  methods: {
    getDisplayNameOrEmail(user) {
      return getDisplayNameOrEmail(user);
    },
    getAccountTypeTag(user) {
      return getAccountTypeTag(user);
    },
    setEditMode(index) {
      this.$emit("setEditMode", { index, isReviews: false });
    },
    setDeleteMode(index) {
      this.$emit("setDeleteMode", { index, isReviews: false });
    },
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    updateComment() {
      this.$emit("updateComment");
    },
    onEditorChange(event) {
       this.$emit("onEditorChange", event.html);

    }
  },
};
</script>

<style>
.comment-container {
  border: 1px solid rgb(207, 205, 205);
  border-radius: 0.375rem;
}
.action {
  cursor: pointer;
}
</style>
